import { type PropsWithChildren, useCallback, useState } from 'react';

import { HeaderContext } from './context';
import type { ITopic } from './IUseHeader';

export const HeaderProvider = ({ children }: PropsWithChildren) => {
  const [title, setTitle] = useState<string>('');
  const [backTitle, setBackTitle] = useState<string>('');
  const [hasBanner, setHasBanner] = useState<boolean>(
    window.navigator.userAgent.includes('iPhone') ||
      window.navigator.userAgent.includes('Android'),
  );
  const [isFavorite, setIsFavorite] = useState<boolean>(false);

  const [topics, setTopics] = useState<ITopic[]>([]);

  const handleSetTitle = useCallback((currentTitle: string) => {
    setTitle(currentTitle);
  }, []);

  const handleSetIsFavorite = useCallback((value: boolean) => {
    setIsFavorite(value);
  }, []);

  const handleSetTopics = useCallback((currentTopics: ITopic[]) => {
    setTopics(currentTopics);
  }, []);

  const handleSetBackTitle = useCallback((currentBackTitle: string) => {
    setBackTitle(currentBackTitle);
  }, []);

  const handleSetHasBanner = useCallback((current: boolean) => {
    setHasBanner(current);
  }, []);

  return (
    <HeaderContext.Provider
      value={{
        hasBanner,
        title,
        topics,
        backTitle,
        onSetTitle: handleSetTitle,
        onSetTopics: handleSetTopics,
        onSetIsFavorite: handleSetIsFavorite,
        isFavorite,
        onSetBackTitle: handleSetBackTitle,
        onSetHasBanner: handleSetHasBanner,
      }}>
      {children}
    </HeaderContext.Provider>
  );
};
